import agendaApiConfig from "../agenda/agendaApiConfig"

export const ProfileService = {
    async getClinicHistory(rut) {
        return await agendaApiConfig.get(`/historialclinico`, {
            params: { pac_rut: rut },
        });
    },
    async getDocumentPdf(params) {
        return await agendaApiConfig.get(`/documento-clinico/api/v1/documentoclinico`,
            {
                params,
                baseURL: process.env.REACT_APP_API_BASE
            }
        );
    }
}